import { render, staticRenderFns } from "./EnderecoForm.vue?vue&type=template&id=3983ec06&scoped=true&"
import script from "./EnderecoForm.vue?vue&type=script&lang=js&"
export * from "./EnderecoForm.vue?vue&type=script&lang=js&"
import style0 from "./EnderecoForm.vue?vue&type=style&index=0&id=3983ec06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3983ec06",
  null
  
)

export default component.exports